
import React, { useState, useEffect, useContext } from "react";
import Header from "../components/dashboard/header";
import SideMenu from "./student/SideMenu";
import Footer from "../components/dashboard/footer";
import { useNavigate, Link } from "react-router-dom";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Loader from "../components/loader";
import SessionPopup from "./SessionPopup"
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
let { lambda, country, appname } = window.app;
const getYouTubeVideoId = (url) => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url?.match(regExp);
    return match && match[7].length === 11 ? match[7] : null;
};
const ViewTest = () => {
    let { id } = useParams();
    const navigate = useNavigate();
    const [msg, setMsg] = useState("");

    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isUserAdd, setIsUserAdd] = useState(false);
    const [titleError, settitleError] = useState('');
    const [statusError, setstatusError] = useState("");
    const [availabiltyError, setavailabiltyError] = useState("");
    const [descriptionError, setdescriptionError] = useState('');
    const [youtubeError, setyoutubeError] = useState('');
    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
    const [editUser, setEditUser] = useState({ title: '', description: '', youtube: "", status: "" });
    const [permission, setPermission] = useState({});
    const [success, setSuccess] = useState(false);
    const [UpdateSuccess, setUpdateSuccess] = useState(false);
    const [image, setImg] = useState('');
    const [manager, setManagers] = useState({});
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [existmsg, setExistMsg] = useState(false);
    const [Ismsg, setIsMsg] = useState(false);
    const [checkStatus, setCheckStatus] = useState(false);
    const [invalidContent, setInvalidContent] = useState(false);
    const { route, setRoute, setCurrentPage, setRowsPerPage, setActiveMenuObj, usePrevious, userData, setActiveMenuId, GetTimeActivity } = useContext(contentContext);
    const [tags, setTags] = useState([]);
    const [input, setInput] = useState("");
    const [showVideoPopup, setShowVideoPopup] = useState(false);

    const prevRoute = usePrevious(route)
    const styles = {
        container: {
            display: "flex",
            flexWrap: "wrap",
            padding: "5px",
            border: "1px solid #ccc",
            borderRadius: "6px",
            maxWidth: "400px"
        },
        tag: {
            display: "flex",
            alignItems: "center",
            background: "#e0e0e0",
            padding: "5px 10px",
            margin: "5px",
            borderRadius: "4px"
        },
        remove: {
            marginLeft: "8px",
            cursor: "pointer",
            color: "#888"
        },
        input: {
            flex: 1,
            border: "none",
            outline: "none",
            minWidth: "100px",
            padding: "5px",
            margin: "5px"
        }
    };
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute !== route) {
            setCurrentPage(1)
            setRowsPerPage(15)
        }
    }, [prevRoute]);
    useEffect(() => {
        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }
    }, [window.site]);

    useEffect(() => {
        if (toastMessage) {
            toast.success(toastMessage, {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // Clear the message after showing to prevent re-triggering
            setToastMessage("");
        }
    }, [toastMessage]);

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        setActiveMenuId(200005)
        setActiveMenuObj({
            "Client Management": false,
            "Contact Management": false,
            "Reports": false
        })
        setRoute("user")
        if (id) {
            getuser();
        }
    }, []);

    const getuser = (e) => {
        GetTimeActivity()
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/lectureLibraryInfo?appname=' + appname + '&lecturelibraryid=' + id + "&token=" + token,
        })
            .then(function (response) {

                let res = response?.data?.result?.data;
                //  console.log("response", response?.data?.result?.[0]);
                if (res === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                    // localStorage.clear();
                    // navigate("/")
                }
                else {

                    if (res.length > 0) {


                        setEditUser(res[0]);
                        setTags(res[0]?.tags)

                    } else {
                        setInvalidContent(true)
                    }
                }
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }
    const onclickInvalid = () => {
        GetTimeActivity()
        setInvalidContent(false)
        navigate('/')
    }

    const handleKeyDown = (e) => {
        if ((e.key === "Enter" || e.key === ",") && input.trim()) {
            e.preventDefault();
            const newTag = input.trim();
            if (!tags.includes(newTag)) {
                setTags([...tags, newTag]);
            }
            setInput("");
        }
    };

    const removeTag = (indexToRemove) => {
        setTags(tags.filter((_, index) => index !== indexToRemove));
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "usertype") {
            if (id) {
                setCheckStatus(true);
            }
            setEditUser(prev => ({ ...prev, [name]: value }));
        }

        if (name === "phone") {
            let formattedValue = value;
            let numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
            const currentIdc = editUser?.idc?.trim(); // Remove unnecessary spaces

            if (currentIdc === "USA") {
                console.log("Using USA Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 6) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
                } else if (numericValue.length > 3) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
                } else {
                    formattedValue = numericValue;
                }
            } else if (currentIdc === "IND") {
                console.log("Using India Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 5) {
                    formattedValue = `${numericValue.slice(0, 5)}-${numericValue.slice(5)}`;
                } else {
                    formattedValue = numericValue;
                }
            }

            // Update the phone number only
            setEditUser(prev => ({ ...prev, phone: formattedValue }));
            return; // Stop further execution for "phone" field
        }

        else if (name === "manager") {
            for (let key in manager) {
                if (manager.hasOwnProperty(key) && manager[key].userid === value) {
                    setEditUser(prev => ({ ...prev, [name]: value }));
                    break; // No need to continue looping after finding the match
                }
            }
        }

        else if (name === "status") {
            if (id) {
                setCheckStatus(true);
            }
            setEditUser(prev => ({ ...prev, [name]: value }));
        }

        else {
            setEditUser(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleAddUser = (e) => {
        GetTimeActivity()
        const isValid = formvalidation();
        if (isValid) {
            createuser();
        }
    }

    function formvalidation() {
        GetTimeActivity()
        let formIsValid = true;

        if (editUser?.title === undefined || editUser?.title?.trim() === "") {
            settitleError("Please Enter Topic");

            setTimeout(function () { settitleError("") }, 3000);
            formIsValid = false;
        }
        if (editUser?.status === undefined || editUser?.status?.trim() === "") {
            setstatusError("Please select a status");
            setTimeout(() => setstatusError(""), 3000);
            formIsValid = false;
        }

        if (editUser?.availability === undefined || editUser?.availability?.trim() === "") {
            setavailabiltyError("Please select availability");
            setTimeout(() => setavailabiltyError(""), 3000);
            formIsValid = false;
        }


        return formIsValid;
    }


    const handleSubmit = () => {
        GetTimeActivity()
        setIsLoading(true)

        const token = localStorage.getItem("token")
        let payload = {}
        payload = {

            // "userType": editUser?.userType,
            "title": editUser?.title,
            "description": editUser?.description,
            "youtube": editUser?.youtube,
            "availability": editUser?.availability,
            "categories": editUser?.categories,
            "status": editUser?.status,
            "userid": localStorage.getItem("userId"),

            "tags": tags,
            "thumbnail": `https://img.youtube.com/vi/${getYouTubeVideoId(editUser?.youtube)}/0.jpg`
        }
        axios({
            method: 'POST',
            url: lambda + '/updateLectureLibrary?appname=' + appname + '&lecturelibraryid=' + id,
            data: payload,
        })
            .then(function (response) {
                if (response) {
                    if (response?.result === "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                        // localStorage.clear();
                        // navigate("/")
                    } else if (response?.data?.result === "This ACM assaigned to companies") {
                        setIsMsg(true);
                        setIsLoading(false);
                    } else {
                        setIsLoading(false);
                        setUpdateSuccess(true)
                        setToastMessage("Lecture Library Updated Successfully")
                    }
                }

            });
    }


    const handleUpdate = (e) => {
        GetTimeActivity()
        const isValid = formvalidation();
        if (isValid) {
            handleSubmit();
        }
    }
    console.log('editUser', editUser)
    const createuser = async () => {
        setIsLoading(true)

        // GetTimeActivity()   
        let payload = {}
        payload = {
            "title": editUser?.title?.trim(),
            "description": editUser?.description?.trim(),
            "youtube": editUser?.youtube?.trim(),
            "categories": editUser?.categories?.trim(),
            "availability": editUser?.availability?.trim(),

            "status": editUser?.status,
            "userid": localStorage.getItem("userId"),
            "tags": tags,
            "thumbnail": `https://img.youtube.com/vi/${getYouTubeVideoId(editUser?.youtube)}/0.jpg`
        }
        const token = localStorage.getItem("token")
        const userId = localStorage.getItem("userId")

        axios({
            method: 'POST',
            url: lambda + "/addLectureLibrary?appname=" + appname + "&userid=" + userId,
            data: payload,
        })
            .then(function (response) {
                if (response) {
                    console.log("response?.result", response)
                    if (response?.data?.result?.data === "User already exists") {
                        setIsLoading(false)
                        setExistMsg(true)

                    }
                    else if (response?.result?.data === "Invalid token or Expired") {
                        // setIsLoading(false)
                        setShowSessionPopupup(true)
                        // localStorage.clear();
                        // navigate("/")
                    }
                    else {
                        setIsLoading(false)
                        setSuccess(true);
                        setToastMessage("Lecture Library Created Successfully")
                        setTimeout(() => {
                            navigate("/lecturelibrary", { state: { restoreListPage: true } }); // Trigger API call AFTER toast is displayed
                        }, 2000);
                    }
                }

            });

    };

    const handleBack = (e) => {
        GetTimeActivity()
        navigate("/lecturelibrary", { state: { restoreListPage: true } })
    }
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <SideMenu />
                <SweetAlert show={invalidContent}
                    custom
                    confirmBtnText="ok"
                    confirmBtnBsStyle="primary"
                    title={"User Not Found"}
                    onConfirm={e => onclickInvalid()}
                >
                </SweetAlert>
                {!invalidContent &&
                    <div className="main-content user-management create-user lecture-library" id="main-content">
                        <div className="page-content" id="page-content">
                            <div className="container-fluid" id="container-fluid">
                                <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                    <div className="col-lg-12">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <h4 className="mb-2 card-title" id="breadcrumb-title">VIEW</h4>
                                                <p className="menu-path" id="breadcrumb-path">
                                                    <span>Learning Hub</span> / <b id="breadcrumb-action">VIEW</b>
                                                </p>
                                            </div>
                                            <div>
                                                <a id="back-button" onClick={handleBack} className="stroke-btn-style create-quiz-btn">
                                                    back
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="create-user-block" id="create-user-block">
                                    {!loading ? (
                                        <>
                                            <div className="form-block" id="form-block">
                                                <div className="row">
                                                    <div >
                                                        <div className="row col-lg-12 col-md-12">
                                                            <div className="col-lg-9 col-md-12 col-sm-12">
                                                                <div className="mb-3 input-field">
                                                                    <label className="form_label">TOPIC</label>
                                                                    <input id="title" disabled name="title"
                                                                        // placeholder="Enter Topic"
                                                                        type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.title} />
                                                                    <span id="title-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{titleError}</span>
                                                                </div>
                                                                <div className="col-lg-12 col-md-12">
                                                                    <div className="mb-3 input-field">
                                                                        <label className="form_label">YOUTUBE VIDEO URL<span className="required"></span></label>
                                                                        <input id="youtube" disabled name="youtube"
                                                                            placeholder="N/A"
                                                                            type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.youtube.trim()} />
                                                                        <span id="youtube-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{youtubeError}</span>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-12 col-md-12">
                                                                    <div className="mb-3 input-field">
                                                                        <label className="form_label">DESCRIPTION<span className="required"></span></label>
                                                                        {/* <input id="description" name="description" placeholder="Enter Description" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.description} /> */}
                                                                        <textarea
                                                                            disabled
                                                                            className="form-control"
                                                                            id="description"
                                                                            type="text"
                                                                            aria-invalid="false"
                                                                            onChange={(e) => handleChange(e)}
                                                                            value={editUser?.description}
                                                                            rows={5}
                                                                            cols={3}
                                                                            name="description"
                                                                            placeholder="N/A">
                                                                        </textarea>
                                                                        <span id="description-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{descriptionError}</span>
                                                                    </div>
                                                                </div>
                                                                {tags && tags.length > 0 &&
                                                                <div className="col-lg-12 col-md-12">
                                                                    <div className="mb-3 input-field">

                                                                        <label className="form_label">Tags</label>
                                                                        <div className="mb-3 input-field">
                                                                            <div className="d-flex">

                                                                                {tags?.map((tag, index) => (
                                                                                    <div key={index} style={styles.tag}>
                                                                                        {tag}
                                                                                        {/* <span style={styles.remove} onClick={() => removeTag(index)}>×</span> */}
                                                                                    </div>
                                                                                ))}
                                                                            </div>




                                                                            {/* <textarea
                                                                                disabled
                                                                                className="form-control"
                                                                                id="productdesc"
                                                                                value={input}
                                                                                onChange={(e) => setInput(e.target.value)}
                                                                                onKeyDown={handleKeyDown}
                                                                                rows={5}
                                                                                cols={3}
                                                                                placeholder="Type and press enter"
                                                                                >
                                                                            </textarea> */}

                                                                        </div>

                                                                    </div>
                                                                </div>}
                                                                <div className="col-lg-12 col-md-12">
                                                                    <div className="mb-3 input-field">
                                                                        <label className="form_label" htmlFor="usertype-select">
                                                                            STATUS
                                                                        </label>
                                                                        <input id="title" disabled name="availablity"
                                                                            // placeholder="Enter Topic"
                                                                            type="text" className="form-control" aria-invalid="false" value={editUser?.status} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-12 col-md-12">
                                                                    <div className="mb-3 input-field">
                                                                        <label className="form_label" htmlFor="usertype-select">
                                                                            AVAILABLITY
                                                                        </label>
                                                                        <input id="title" disabled name="availablity"
                                                                            // placeholder="Enter Topic"
                                                                            type="text" className="form-control" aria-invalid="false" value={editUser?.availability} />
                                                                        {/* <select
                                                                            disabled
                                                                            id="usertype-select"
                                                                            className="colorselect capitalize form-control form-select"
                                                                            name="availability"
                                                                            onChange={handleChange} value={editUser?.availability}
                                                                        >
                                                                            <option value="">Select availability</option>
                                                                            <option value="free">FREE</option>
                                                                            <option value="subscription">SUBSCRIPTION</option>
                                                                        </select> */}
                                                                        {/* <span id="status-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{availabiltyError}</span> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-3">
                                                                <div className="col-lg-12 col-md-12">
                                                                    {
                                                                        getYouTubeVideoId(editUser?.youtube) ? (
                                                                            <div style={{ marginTop: "10px" }}>
                                                                                <img
                                                                                    src={`https://img.youtube.com/vi/${getYouTubeVideoId(
                                                                                        editUser?.youtube
                                                                                    )}/0.jpg`}
                                                                                    alt="YouTube Thumbnail"
                                                                                    style={{
                                                                                        width: "100%",
                                                                                        maxWidth: "300px",
                                                                                        cursor: "pointer",
                                                                                    }}
                                                                                    onClick={() => setShowVideoPopup(true)}
                                                                                />
                                                                                <p className="d-flex justify-content-start align-items-center gap-2"
                                                                                    style={{ cursor: "pointer" }}
                                                                                    onClick={() => setShowVideoPopup(true)}
                                                                                >
                                                                                    <span className="material-symbols-outlined">
                                                                                        smart_display
                                                                                    </span> <span className="pre-vid-txt">Preview Video</span>
                                                                                </p>
                                                                            </div>) : <div
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "180px",
                                                                                    backgroundColor: "#ffffff",
                                                                                    border: "1px dashed #EA7F4A",
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "center",
                                                                                    color: "#EA7F4A",
                                                                                    fontWeight: "bold",
                                                                                    borderRadius: "8px",
                                                                                }}
                                                                            >
                                                                            No Image
                                                                        </div>
                                                                    }

                                                                    {showVideoPopup && (
                                                                        <div
                                                                            style={{
                                                                                position: "fixed",
                                                                                top: 0,
                                                                                left: 0,
                                                                                width: "100%",
                                                                                height: "100%",
                                                                                backgroundColor: "rgba(0,0,0,0.8)",
                                                                                zIndex: 1000,
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                            }}
                                                                            onClick={() => setShowVideoPopup(false)}
                                                                        >
                                                                            <div style={{ position: "relative", width: "80%", maxWidth: "800px" }}>
                                                                                <iframe
                                                                                    width="100%"
                                                                                    height="450"
                                                                                    src={`https://www.youtube.com/embed/${getYouTubeVideoId(
                                                                                        editUser?.youtube
                                                                                    )}`}
                                                                                    frameBorder="0"
                                                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                                    allowFullScreen
                                                                                    title="Video Preview"
                                                                                ></iframe>
                                                                                <button className="video-btn-close"
                                                                                    onClick={() => setShowVideoPopup(false)}
                                                                                    style={{
                                                                                        position: "absolute",
                                                                                        color: "white",
                                                                                        border: "none",
                                                                                        cursor: "pointer",
                                                                                        borderRadius: "6px",

                                                                                    }}
                                                                                ><span className="material-symbols-outlined">close</span>

                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>

                                                        </div>


                                                        <style>
                                                            {
                                                                `
        textarea.form-control {
        min-height: calc(6.5em + .75rem + 2px) !important;}
        `
                                                            }
                                                        </style>








                                                    </div>
                                                </div>
                                            </div>

                                            {/* <div className="row">
                                                <div className="col-md-12">
                                                    <button id="submit-button" className="fill-btn-style create-quiz-btn" style={{ border: '0' }} type="submit" onClick={e => id === undefined ? handleAddUser(e) : handleUpdate(e)}>

                                                        {id === undefined ? "Create" : "Update"}
                                                    </button>
                                                </div>
                                                {msg && <span id="success-msg" className="errormsg" style={{ fontWeight: 'bold', color: 'green' }}>{msg}</span>}
                                            </div> */}
                                        </>
                                    ) : (
                                        <div className="form-block" id="loading-block">
                                            <div className="tab-content p-3 text-muted">
                                                <div className="tab-pane active show" id="home1" role="tabpanel">
                                                    <div className="row">
                                                        <Loader />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <Footer id="footer" />
                    </div>

                }



        </div >
            <ToastContainer
                id="toastContainer"
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

        </>
    );
};

export default ViewTest;